module.exports = __webpack_public_path__ + "img/new-logo.1636fc21.png";